@if (this.form.length > 0) {
  <cam-form
    class="form"
    [inputs]="this.form"
    [error]="this.error"
    [loader]="this.loader"
    (valid)="this.onSaveClick($any($event))"
  >
  </cam-form>
}
